module.exports = __webpack_public_path__ + "aea0197d4d716b4379e3415d23f21e36.woff2";